/**
 * This class initiates various logic for our site header
 * 
 * @export
 * @class SiteHeader
 */
import { BaseModule } from '../../helpers/base_module';
import { get } from '../../helpers/utilities';

export class SiteHeader extends BaseModule {
    public static  headerHeight           = 98;
    private static backgroundTriggerPoint = 10;
    public disableChange                  = false;
    public container                     = <Element>get('#js-site-header');


    /**
     * Initiate our class
     * 
     * @class SiteHeader
     */
    constructor() {
        super();
        super.makePublic('site_header');
        if(!this.container) return;

        this.bindEvents();
    }


    /**
     * Bind our events for the elements in the header.
     */
    private bindEvents(): void {

        // Toggle the header background on scroll
        this.toggleBackground();
        window.addEventListener('scroll', () => {
            if(!this.disableChange) this.toggleBackground();
        });
    }

    
    /**
     * Toggle the background for the header depending on the current scroll position
     * 
     * @public
     * @memberof SiteHeader
     */
    public toggleBackground(): void {
        if((window.scrollY || window.pageYOffset) >= SiteHeader.backgroundTriggerPoint) {
            this.addbackground();
        } else {
            this.removeBackground();
        }
    }


    /**
     * Adds the background style class from the header.
     * 
     * @public
     * @memberof SiteHeader
     */
    public addbackground(): void {
        this.container.classList.add('c-site-header--is-fixed');
    }


    /**
     * Removes the background style class from the header.
     * 
     * @public
     * @memberof SiteHeader
     */
    public removeBackground(): void {
        this.container.classList.remove('c-site-header--is-fixed');
    }
}
